import type { DashboardReport } from "@/pages/dashboard/types";

import ReportRow from "@/pages/dashboard/components/report-row";

interface ReportCardProps {
  report: DashboardReport;
}

/**
 * One report card (e.g. "리포트 (수요자 측)"):
 *   - Title + total count badge in the header
 *   - Inner card with "가장 활발한 ..." sub-header
 *   - List of ReportRow items
 *
 * Mirrors the Figma "Body" / "Info-Row" pattern in node 984:15090.
 */
const ReportCard = ({ report }: ReportCardProps) => {
  const { title, totalLabel, totalValue, totalUnit, listTitle, items } = report;

  return (
    <div className="bg-white border border-[rgba(0,0,0,0.09)] rounded-[16px] flex-1 min-w-px flex flex-col gap-6 px-5 py-6 overflow-hidden">
      {/* Header: title + total badge */}
      <div className="flex items-center justify-between w-full">
        <p className="text-lg leading-6 tracking-[-0.18px] font-bold text-[#000000] whitespace-nowrap">
          {title}
        </p>
        <div className="inline-flex items-center justify-center h-6 pl-1 pr-2 rounded bg-[#FDF5EE] overflow-hidden">
          <p className="text-base leading-6 tracking-[-0.16px] whitespace-nowrap">
            <span className="text-[#000000]">{`${totalLabel}: `}</span>
            <span className="font-bold text-black">
              {totalValue.toLocaleString()}
              {totalUnit}
            </span>
          </p>
        </div>
      </div>

      {/* Inner list card */}
      <div className="bg-white border border-[rgba(0,0,0,0.09)] rounded flex flex-col overflow-hidden w-full">
        <div className="flex items-center px-4 py-4 border-b border-[rgba(0,0,0,0.09)] w-full">
          <p className="flex-1 text-sm leading-5 tracking-[-0.14px] font-bold text-black">
            {listTitle}
          </p>
        </div>

        <div className="flex flex-col px-4 pb-5 pt-0 w-full">
          {items.map((item) => (
            <ReportRow key={item.name} item={item} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ReportCard;
